<template>
    <!--分类新闻模块-->
    <div id="tabs" class="container">
        <!--v-bind:class="[ activetab === 1 ? active : '',]"-->
        <div class="tabs">
            <a v-on:click="activetab=1" v-bind:class="[activetab===1 ? active : '', noActive]" v-text="title1"></a>
            <a v-on:click="activetab=2" v-bind:class="[activetab===2 ? active : '', noActive]" v-text="title2"></a>
            <div class="more-btn" @click="$router.push('/HeaderNewsList?id='+ cate_id1)">more</div>
        </div>
        <div class="content">
            <div v-if="activetab === 1" class="tabcontent">
                <div class="news-list">
                    <div :key="index" v-for="(item, index) in newsClass_1">
                        <router-link class="first-news" v-if="item.type===1" :to="{path:'article',query:{id:item.art_id,cate:item.types_name}}" tag="div">
                            <img :src="item.logo" alt="" v-if="item.logo!==''" style="margin-right:10px;">
                            <a v-text="item.title" class='content-title'></a>
                        </router-link>
                        <router-link class="first-news" v-if="item.type===2" :to="{ path: 'complainInfo',query:{id:item.id,cate:item.types_name}}" tag="div">
                            <img :src="item.logo" alt="" v-if="item.logo!==''" style="margin-right:10px;">
                            <a v-text="item.title" class='content-title'></a>
                        </router-link>
                    </div>
                </div>
            </div>
            <div v-if="activetab === 2" class="tabcontent">
                <div :key="index" v-for="(item, index) in newsClass_2">
                    <router-link class="first-news" v-if="item.type===1" :to="{path:'article',query:{id:item.art_id,cate:item.types_name}}" tag="div">
                        <img :src="item.logo" alt="" v-if="item.logo!==''" style="margin-right:10px;">
                        <a v-text="item.title" class='content-title' style="padding-top:2px;"></a>
                    </router-link>
                    <router-link class="first-news" v-if="item.type===2" :to="{ path: 'complainInfo',query:{id:item.id,cate:item.types_name}}" tag="div">
                        <img :src="item.logo" alt="" v-if="item.logo!==''" style="margin-right:10px;">
                        <a v-text="item.title" class='content-title' style="padding-top:2px;"></a>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NewsTab",
    props: [
        'newsClass_1', 'newsClass_2', 'title1', 'title2', 'cate_id1', 'cate_id2'
    ],
    data() {
        return {
            activetab: 1,
            noActive: 'default',
            active: 'active'
        }
    },
    mounted() {

    }
}
</script>
<style scoped>
/* RESET */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

/* STYLING */
.container {
    width: 370px;
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    color: #888;
    margin: 16px 45px 30px 0;
    height: 300px;
    overflow: hidden;
}

.container:nth-child(3n+3) {
    margin-right: 0;
}

/* Style the tabs */
.tabs {
    overflow: hidden;
    border-bottom: 2px solid #4a90e2;
    margin-bottom: 20px;
    position: relative;
}

.tabs ul {
    list-style-type: none;
    margin-left: 16px;
}

.tabs a {
    float: left;
    cursor: pointer;
    padding: 4px 10px;
    transition: background-color 0.2s;
    border-right: none;
    font-weight: bold;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    line-height: 26px;
}

.tabs .more-btn {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 16px;
    font-weight: 600;
    color: #5fb071;
    line-height: 36px;
    padding: 0 10px;
    cursor: pointer;
}

/* Styling for active tab */
.tabs a.active {
    /* background-color: #294b7f; */
    color: #ff5300;
    cursor: default;
}

/* Style the tab content */
.tabcontent {
    min-height: 260px;
}

.news-list {
    height: 321px;
}

.first-news {
    display: flex;
    margin-bottom: 7px;
}

.first-news>img {
    display: none;
}

.first-news:nth-child(1)>img {
    display: block;
    width: 160px;
    height: 100px;
    object-fit: cover;
}

.first-news>a {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(51, 51, 51, 1);
    line-height: 21px;
}

.content-title {
    display: inline-block;
    width: 333px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.news {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(51, 51, 51, 1);
    line-height: 19px;
    margin: 7px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.default {
    font-size: 20px;
    font-weight: bold;
    color: rgba(153, 153, 153, 1)
}
</style>